export function formatGroupedNumber(value: number, fractionDigits?: number): string {
  const whole = Math.abs(value - Math.round(value)) < 1e-9;
  const digits = fractionDigits ?? (whole ? 0 : 2);
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
}

export function formatHours(value: number | null | undefined): string {
  if (value == null) return "—";
  return `${formatGroupedNumber(value, 2)} h`;
}

export function formatHoursSentence(value: number): string {
  const whole = Math.abs(value - Math.round(value)) < 1e-9;
  return `${formatGroupedNumber(value, whole ? 0 : 2)} hours`;
}

export function formatRupees(value: number | null | undefined): string {
  if (value == null) return "—";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatFte(
  value: number | null | undefined,
  parallel: boolean,
): string {
  if (value == null) return "—";
  return value.toFixed(parallel ? 2 : 1);
}

export function formatRomDate(value: string | null | undefined): string {
  if (!value) return "—";
  const match = /^(\d{4}-\d{2}-\d{2})/.exec(value);
  return match ? match[1] : "—";
}
